<template>
  <main class="login__container">
    <div class="row mx-0 login__row">
      <div class="col-12 col-lg-4 bg-light-grey-600 d-flex justify-content-center">
        <form class="d-flex flex-column justify-content-between login__form" ref="form" method="GET" :action="actionLink" @submit="checkDomain">
          <div class="d-flex flex-column login__form-wrapper">
            <svg width="135" height="27" viewBox="0 0 135 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_132_9458)">
                <path d="M33.5054 7.56177C37.0279 7.56177 39.9737 9.82499 40.6329 13.04H38.1815C37.5635 11.1364 35.7301 9.90959 33.5672 9.90959C30.642 9.90959 28.582 12.0882 28.582 15.2186C28.582 18.3702 30.6008 20.5488 33.5672 20.5488C35.8537 20.5488 37.7283 19.2163 38.2639 17.2069H33.1346V15.1129H40.8388C40.777 19.6393 37.7901 22.8967 33.5672 22.8967C29.3236 22.8967 26.1719 19.6605 26.1719 15.2186C26.1719 10.8191 29.2824 7.56177 33.5054 7.56177ZM42.0954 16.9108C42.0954 13.4842 44.5674 10.9249 47.8221 10.9249C51.2211 10.9249 53.4871 13.6111 53.4871 16.9319C53.4871 17.1857 53.4665 17.4607 53.4459 17.7145H44.4232C44.691 19.5547 45.9888 20.6969 47.8221 20.6969C49.1405 20.6969 50.2323 20.0624 50.8091 19.0259H53.2193C52.3335 21.4372 50.2941 22.8967 47.8221 22.8967C44.5674 22.8967 42.0954 20.3162 42.0954 16.9108ZM51.2005 15.8109C50.7885 14.0765 49.5113 13.04 47.8221 13.04C46.0918 13.04 44.8558 14.0976 44.4644 15.8109H51.2005ZM55.5058 22.6217V11.1998H57.1332L57.5246 12.6805C58.3486 11.6017 59.6258 10.946 60.9853 10.946C62.4891 10.946 63.6839 11.7075 64.3225 12.9343C65.1259 11.7075 66.4855 10.946 67.948 10.946C70.2964 10.946 71.8826 12.7651 71.8826 15.3667V22.6217H69.596V15.9378C69.596 14.0976 68.8132 13.04 67.433 13.04C65.9499 13.04 64.8169 14.436 64.8169 16.382V22.6217H62.5715V15.9378C62.5715 14.0976 61.8093 13.04 60.4085 13.04C58.9254 13.04 57.7924 14.436 57.7924 16.382V22.6217H55.5058ZM74.7665 22.6217V7.81559H80.1018C82.8828 7.81559 85.0046 9.88844 85.0046 12.7016C85.0046 15.4936 82.9034 17.5876 80.1018 17.5876H77.1355V22.6217H74.7665ZM77.1355 15.2821H79.9782C81.5232 15.2821 82.615 14.2034 82.615 12.7016C82.615 11.221 81.5232 10.1211 79.9782 10.1211H77.1355V15.2821ZM85.9934 16.9108C85.9934 13.4631 88.4859 10.9249 91.8025 10.9249C93.4298 10.9249 94.8512 11.5594 95.8606 12.617L96.1284 11.1998H97.9V22.6217H96.046L95.8194 21.2257C94.81 22.2833 93.4092 22.8967 91.8025 22.8967C88.4859 22.8967 85.9934 20.3373 85.9934 16.9108ZM88.3211 16.9108C88.3211 19.0471 89.8867 20.6546 91.9673 20.6546C94.0684 20.6546 95.5928 19.0682 95.5928 16.9108C95.5928 14.7533 94.0684 13.1669 91.9673 13.1669C89.8867 13.1669 88.3211 14.7745 88.3211 16.9108ZM99.9187 16.6146C99.9187 13.4208 102.329 10.9249 105.419 10.9249C107.046 10.9249 108.488 11.5806 109.477 12.6805L109.848 11.1998H111.352V21.1199C111.352 24.7792 109.23 27.0001 105.79 27.0001C102.947 27.0001 100.928 25.4772 100.351 22.9601H102.638C103.07 24.2292 104.368 24.9061 105.769 24.9061C107.705 24.9061 109.106 23.6158 109.106 21.4372V20.9296C108.138 21.7756 106.861 22.2833 105.419 22.2833C102.329 22.2833 99.9187 19.8085 99.9187 16.6146ZM102.246 16.6146C102.246 18.6029 103.709 20.1047 105.687 20.1047C107.664 20.1047 109.106 18.624 109.106 16.6146C109.106 14.5841 107.664 13.1035 105.687 13.1035C103.709 13.1035 102.246 14.6052 102.246 16.6146ZM113.37 16.9108C113.37 13.4842 115.842 10.9249 119.097 10.9249C122.496 10.9249 124.762 13.6111 124.762 16.9319C124.762 17.1857 124.741 17.4607 124.721 17.7145H115.698C115.966 19.5547 117.264 20.6969 119.097 20.6969C120.415 20.6969 121.507 20.0624 122.084 19.0259H124.494C123.608 21.4372 121.569 22.8967 119.097 22.8967C115.842 22.8967 113.37 20.3162 113.37 16.9108ZM122.475 15.8109C122.063 14.0765 120.786 13.04 119.097 13.04C117.367 13.04 116.131 14.0976 115.739 15.8109H122.475ZM128.181 19.0048C128.243 20.2104 129.232 20.8238 130.571 20.8238C131.786 20.8238 132.734 20.295 132.734 19.3432C132.734 18.2645 131.539 18.0107 130.18 17.778C128.326 17.4607 126.142 17.0165 126.142 14.3726C126.142 12.3209 127.873 10.9249 130.447 10.9249C133.043 10.9249 134.712 12.3632 134.753 14.5841H132.59C132.549 13.4842 131.745 12.9131 130.406 12.9131C129.129 12.9131 128.346 13.4631 128.346 14.288C128.346 15.3032 129.5 15.5148 130.839 15.7263C132.713 16.0647 135 16.4243 135 19.2374C135 21.4584 133.187 22.8967 130.489 22.8967C127.77 22.8967 125.998 21.3738 125.936 19.0048H128.181Z" fill="#080823" />
                <path d="M23.6176 0.0106099L0.123712 7.56172C0.0310137 7.59345 -0.0204855 7.69921 0.000114182 7.80497L1.81289 13.9284C1.84379 14.0235 1.94678 14.087 2.03948 14.0553L19.2711 8.51355C20.0951 8.24915 20.7852 7.65691 21.1869 6.86372C22.2581 4.74856 23.1439 2.5488 23.8236 0.264429C23.8854 0.0952162 23.7618 -0.0316933 23.6176 0.0106099Z" fill="#FFBB1C" />
                <path d="M17.9838 10.5969L3.38892 15.282C3.30652 15.3137 3.25502 15.3983 3.28592 15.4829L4.8206 20.6545C4.8515 20.7391 4.93389 20.792 5.00599 20.7603L14.317 17.7673C15.0174 17.5452 15.5942 17.0376 15.9341 16.3713C16.8405 14.584 17.5924 12.7227 18.1589 10.7979C18.2104 10.671 18.0971 10.5546 17.9838 10.5969Z" fill="#E8486C" />
                <path d="M12.4322 20.0518L6.34501 22.0083C6.27291 22.0295 6.24201 22.1035 6.26261 22.1775L7.56039 26.5453C7.58099 26.6194 7.65309 26.6617 7.72519 26.6299L9.34226 26.1117C9.92936 25.9214 10.4237 25.4983 10.7121 24.9272C11.4846 23.4149 12.1129 21.8497 12.597 20.2104C12.6279 20.1153 12.5352 20.0095 12.4322 20.0518Z" fill="#476DF2" />
              </g>
              <defs>
                <clipPath id="clip0_132_9458">
                  <rect width="135" height="27" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div class="login__form-container">
              <p class="login__welcome">
                {{ $t("login.leftTitle") }}
              </p>
              <p v-if="loginError" class="paragraph-14-regular mt-3 mt-lg-4 login__error login__desc">
                {{ loginError }}
              </p>
              <p class="paragraph-14-regular mt-4px text-lightmode login__desc">
                {{ $t("login.desc") }}
              </p>
              <p class="paragraph-14-medium login__light-low mt-4">
                {{ $t("login.inputTitle") }}
              </p>
              <div class="mt-4px login__input">
                <input type="text" class="border-radius" name="shop" required v-focus :title="$t('agency.domain')" placeholder="example.myshopify.com" v-model="domain" :class="inputDynamicClass" />
                <span class="mr-2 login__input-icon" v-if="isError">
                  <i class="icon icon-warning login__error"></i>
                </span>
                <span class="mt-4px login__error login__input-message" v-if="isError">
                  {{ alertText }}
                </span>
              </div>

              <button type="submit" class="btn btn-default btn-primary btn-block border-radius py-1 text-light mt-5">
                {{ $t("agency.signin") }}
              </button>
            </div>
          </div>

          <p class="mt-2">
            <span class="mr-4px login__light-low">{{ $t("login.link1") }}</span>
            <a href="https://apps.shopify.com/GemPages" target="_blank" class="text-mono3">{{ $t("login.link2") }}</a>
          </p>
        </form>
      </div>
      <div class="d-none d-lg-block col-lg-8 login__right">
        <p class="text-mono3 login__join" v-html="$t('login.rightTitle')">
        </p>
      </div>
    </div>
  </main>
</template>

<script>
import { serverDomain } from "@/config/index.js";

export default {
  name: "ResponsiveLogin",
  data: () => ({
    alertText: null,
    domain: "",
    hasExpired: false,
    invalidShop: false
  }),
  computed: {
    isError() {
      return this.alertText && this.alertText.length;
    },
    inputDynamicClass() {
      return {
        error: this.isError
      };
    },
    actionLink() {
      return serverDomain() + "/login";
    },
    loginError() {
      if(this.hasExpired) return this.$t("login.sessionExpired")
      if(this.invalidShop) return this.$t("login.invalidShop")
      return false
    }
  },
  created() {
    if(this.$route.hash == "#invalidShop") {
      this.invalidShop = true
      this.$router.replace({
        ...this.$router.currentRoute,
        hash: null
      })
    }

    this.checkSession();
  },
  methods: {
    checkDomain(e) {
      const affix = "myshopify.com";
      // const affixes = [];
      this.alertText = "";
      const pattern = /^[a-zA-Z0-9]([a-zA-Z0-9-])*.myshopify.com$/;
      const domain = this.domain && this.domain.trim() || "";

      try {
        if (!domain || !domain.length) {
          throw new Error(this.$t("login.error1"));
        }

        if (domain.endsWith(".")) {
          if (domain.indexOf("." + affix) > -1) {
            throw new Error(this.$t("login.error1"));
          }
          const autoDomain = domain + affix;
          if (pattern.test(autoDomain)) {
            this.domain = autoDomain;
            return true;
          } else {
            throw new Error(this.$t("login.error2"));
          }
        } else {
          if (domain.indexOf("." + affix) > -1) {
            return true;
          }
          const autoDomain = domain + "." + affix;
          if (pattern.test(autoDomain)) {
            this.domain = autoDomain;
            return true;
          } else {
            throw new Error(this.$t("login.error2"));
          }
        }
      } catch (err) {
        this.alertText = err.message;
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    },
    checkSession() {
      const sessionExpired = window.localStorage.getItem("gpSessionExpired");
      if (sessionExpired) {
        this.hasExpired = true;
        window.localStorage.removeItem("gpSessionExpired");
      }
    }
  }
};
</script>

<style lang="scss">
$padding-top-lg: 108px;
$padding-bottom-lg: 85px;
$screen-lg: 1024px;

$padding-top-sm: 60px;
$padding-bottom-sm: 36px;

$color-accent-red: #f44336;
$color-light-low: #545a74;

$max-width-form: 320px;

.login {
  &__right {
    min-height: 100%;
    background-image: url("~@/core/assets/login/login-background.svg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  &__join {
    font-weight: 600;
    font-size: 46px;
    line-height: 58px;
    padding-top: $padding-top-lg;
    padding-left: 15.5%;
  }

  &__row {
    max-width: 100vw;
    width: 100%;
    min-height: 100vh;
  }

  &__form {
    height: 100%;
    max-width: $max-width-form;

    padding-top: $padding-top-sm;
    padding-bottom: $padding-bottom-sm;

    @media (min-width: $screen-lg) {
      padding-top: $padding-top-lg;
      padding-bottom: $padding-bottom-lg;
    }

    &-wrapper {
      align-items: center;

      @media (min-width: $screen-lg) {
        & {
          align-items: start;
        }
      }
    }

    &-container {
      margin-top: 80px;
    }
  }

  &__welcome {
    color: #071a5f;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;

    @media (min-width: $screen-lg) {
      & {
        text-align: left;
        font-size: 32px;
        line-height: 36px;
      }
    }
  }

  &__desc {
    text-align: center;

    @media (min-width: $screen-lg) {
      & {
        text-align: left;
      }
    }
  }

  &__input {
    position: relative;

    input {
      width: 100%;
      height: 100%;
      border: 1px solid $color-light-low;
      color: $color-light-low;

      &::placeholder {
        color: $color-light-low;
      }

      &.error {
        border-color: $color-accent-red;
        color: $color-accent-red;

        &::placeholder {
          color: $color-accent-red;
        }
      }
    }

    &-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      font-size: 20px;
    }

    &-message {
      position: absolute;
      top: 100%;
      left: 0;
      font-size: 12px;
      line-height: 150%;
    }
  }

  &__error {
    color: $color-accent-red;
  }

  &__light-low {
    color: $color-light-low;
  }
}
</style>
